// assets/refresh-after-add-to-cart.js
(() => {
  // Only run on this specific page
  if (window.location.pathname !== '/pages/beekeeping-show-pre-order-portal') return;

  let reloading = false;
  const reloadSoon = () => {
    if (reloading) return;
    reloading = true;

    // small delay lets Shopify/theme finish any async cart write
    setTimeout(() => {
      window.location.reload();
    }, 250);
  };

  // 1) Catch classic form submits to /cart/add
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = (form.getAttribute('action') || '').toLowerCase();
      if (action.includes('/cart/add')) {
        // If theme prevents navigation and does AJAX, our fetch/XHR hooks below handle it.
        // If it actually submits normally, the page will navigate anyway.
        // So we only reload if the submit was prevented.
        setTimeout(() => {
          if (e.defaultPrevented) reloadSoon();
        }, 0);
      }
    },
    true
  );

  // 2) Intercept fetch() calls to /cart/add or /cart/add.js
  const originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = async (...args) => {
      const res = await originalFetch(...args);

      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
        if (url && url.includes('/cart/add') && res.ok) reloadSoon();
      } catch (_) {}

      return res;
    };
  }

  // 3) Intercept XHR calls to /cart/add or /cart/add.js (some themes use XHR instead of fetch)
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._ha_url = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      try {
        const url = this._ha_url || '';
        if (typeof url === 'string' && url.includes('/cart/add') && this.status >= 200 && this.status < 300) {
          reloadSoon();
        }
      } catch (_) {}
    });

    return originalSend.apply(this, args);
  };
})();
